import React from 'react';

import Card from './components/card';
import useGet from '../../hook/use-get';
import { API } from '../../helpers/constants';
import { grouping } from '../../helpers/array';
import LoadingListItem from './components/loading-list-item';
import Error from '../../components/error';

const Licensing = () => {
  const { data, isFetching, isError, refetch } = useGet({
    queryKey: 'licenses',
    api: API.licenses
  });
  const licenseData = grouping('category', data);

  const renderContent = () => {
    if (isFetching) {
      return (
        <>
          <div className="h-10 w-80 bg-gray-200 mb-4" />
          <div className="grid grid-cols-1 mx-auto md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
            {Array(3)
              .fill(0)
              .map(() => (
                <LoadingListItem />
              ))}
          </div>
          <div className="h-10 w-80 bg-gray-200 mb-4" />
          <div className="grid grid-cols-1 mx-auto md:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array(3)
              .fill(0)
              .map(() => (
                <LoadingListItem />
              ))}
          </div>
        </>
      );
    }

    if (isError) {
      return <Error refetch={refetch} />;
    }

    return (
      <>
        {licenseData?.map((item) => (
          <div key={item.category} className="mb-16">
            <h3 className="text-xl lg:text-2xl font-bold pb-3 text-left">{item.category}</h3>
            <div className="grid grid-cols-1 mx-auto md:grid-cols-2 lg:grid-cols-3 gap-6">
              {item?.data?.map((item) => (
                <Card
                  key={item?.title}
                  title={item?.title}
                  sourceImage={item?.['cover_url']}
                  url={item?.url}
                />
              ))}
            </div>
          </div>
        ))}
      </>
    );
  };

  return (
    <div className="w-[90%] m-auto py-10">
      <h1 className="text-2xl lg:text-4xl font-bold pb-3">Pengurusan Perijinan</h1>
      <div className="my-7 mx-5">{renderContent()}</div>
    </div>
  );
};

export default Licensing;
